module.exports = __webpack_public_path__ + "img/battery-diagnostic.17ac4c24.svg";